import { defineComponent as _defineComponent } from 'vue'
import { computed } from "@vue/reactivity";
import { ref } from "vue";
import ToggleButton from "../shared/button/ToggleButton.vue";
import InlineSvg from "vue-inline-svg";
import { useUserStore } from "@/stores/userStore";
import { useServiceStore } from "@/stores/serviceStore";


const __default__ = {
  name: "LineInfoDetailFooter",
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  isFavorite: {
    type: Boolean,
    default: false,
  },
  isMonthlyBookAvailable: {
    type: Boolean,
    default: false,
  },
  isDailyBookAvailable: {
    type: Boolean,
    default: false,
  },
  isLoggedIn: {
    type: Boolean,
    default: false,
  },
},
  emits: ["onClickFavorite", "onClickDailyBook", "onClickMonthlyBook"],
  setup(__props, { expose: __expose, emit: __emit }) {

const props = __props;

const emit = __emit;

const serviceStore = useServiceStore();
const userStore = useUserStore();

const shouldShowUserRemainBookCount = computed(
  () => !!serviceStore.serviceInfo?.shouldShowRemainBookCount
);

const userRemainBookCount = computed(
  () => `${userStore.remainBookCount ?? "-"}`
);

const isBookCountExceeded = computed(
  () =>
    shouldShowUserRemainBookCount.value && (userStore.remainBookCount ?? 0) <= 0
);

/** 예약제한 상태 여부 */
const isBookBlocked = computed(() => userStore.isBookBlocked);

const isBookable = computed(
  () => props.isDailyBookAvailable || props.isMonthlyBookAvailable
);

const favoriteImage = computed(() => {
  return props.isFavorite
    ? require("@/assets/icons/star-filled.svg")
    : require("@/assets/icons/star.svg");
});

const favoriteBtnTitle = computed(() =>
  props.isFavorite ? "즐겨찾기 삭제" : "즐겨찾기 추가"
);

const onClickFavorite = () => {
  hideTips(0);
  emit("onClickFavorite", !props.isFavorite);
};

const shouldShowTips = ref(false);
const hideTips = (delayMillis: number) => {
  setTimeout(() => {
    shouldShowTips.value = false;
  }, delayMillis);
};
const showTips = (durationMillis: number) => {
  shouldShowTips.value = true;
  hideTips(durationMillis);
};

const onClickBook = () => {
  if (isBookBlocked.value) return;
  props.isDailyBookAvailable ? onClickDailyBook() : onClickMonthlyBook();
};

const onClickDailyBook = () => {
  hideTips(0);
  emit("onClickDailyBook");
};

const onClickMonthlyBook = () => {
  hideTips(0);
  emit("onClickMonthlyBook");
};

__expose({ showTips });

const __returned__ = { props, emit, serviceStore, userStore, shouldShowUserRemainBookCount, userRemainBookCount, isBookCountExceeded, isBookBlocked, isBookable, favoriteImage, favoriteBtnTitle, onClickFavorite, shouldShowTips, hideTips, showTips, onClickBook, onClickDailyBook, onClickMonthlyBook, ToggleButton, get InlineSvg() { return InlineSvg } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})